import React from 'react';
import { Box, Container, Typography } from '@mui/material';

/**
 * A full-bleed image band with one line of copy over it.
 *
 * The page argues for nineteen screens and shows the promise exactly once, in
 * the hero. These bands carry the dream through the rest of the page: they are
 * the only places a reader gets to picture the outcome instead of read about it.
 *
 * Uses a real <img> rather than a background so the picture has alt text and
 * can lazy load. The scrim sits above it and only needs to buy contrast for the
 * text, so it is lightest where the image is most likely to be interesting.
 */
const DreamBand = ({ image, alt, headline, sub, position = 'center', height }) => (
  <Box
    sx={{
      position: 'relative',
      overflow: 'hidden',
      height: height || { xs: 380, md: 520 },
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      textAlign: 'center',
    }}
  >
    <Box
      component="img"
      src={image}
      alt={alt}
      loading="lazy"
      sx={{
        position: 'absolute',
        inset: 0,
        width: '100%',
        height: '100%',
        objectFit: 'cover',
        objectPosition: position,
      }}
    />
    <Box
      sx={{
        position: 'absolute',
        inset: 0,
        background:
          'linear-gradient(180deg, rgba(15,31,61,0.84) 0%, rgba(15,31,61,0.68) 45%, rgba(15,31,61,0.88) 100%)',
      }}
    />
    <Container maxWidth="md" sx={{ position: 'relative', zIndex: 1 }}>
      <Typography variant="h2" sx={{ color: 'common.white', mb: 2 }}>
        {headline}
      </Typography>
      {sub && (
        <Typography variant="subtitle1" sx={{ color: 'common.white', maxWidth: 640, mx: 'auto' }}>
          {sub}
        </Typography>
      )}
    </Container>
  </Box>
);

export default DreamBand;
